"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// These methods correspond to Tracking interface @vp/tracking trackingJS.Tracking
const trackingMethods = ["page", "track", "trackLink", "trackNavigation", "identify", "reset", "setAnonymousId"];
function TrackingStub() {
  const calls = [];
  let trackingInstance = undefined;
  const factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments);
      if (trackingInstance !== undefined) {
        trackingInstance[method].apply(trackingInstance, args);
      } else {
        args.unshift(method);
        calls.push(args);
      }
    };
  };
  for (let i = 0; i < trackingMethods.length; i++) {
    const key = trackingMethods[i];
    this[key] = factory(key);
  }
  this.version = () => "tracking-stub";
  this.visit = () => null;
  this.getCalls = () => calls;
  this.resetCalls = () => {
    trackingInstance = undefined;
    calls.length = 0;
  };
  this.setTrackingAndReplay = tracking => {
    if (trackingInstance !== undefined || tracking === undefined) {
      return;
    }
    trackingInstance = tracking;
    while (calls.length > 0) {
      const callArgs = calls.shift();
      try {
        const method = callArgs.shift();
        trackingInstance[method].apply(trackingInstance, callArgs);
      } catch (e) {
        console.log("Failed to replay a tracking call " + JSON.stringify(callArgs), e);
      }
    }
  };
}
var _default = new TrackingStub();
exports.default = _default;